import CookieHelper from '../utils/CookieHelper'
import { v4 as uuidv4 } from 'uuid'
import { useEffect, useState } from 'react'
import { getIsVariationTrue } from '../services/optimizelyService'
import { getFeaturesVariables } from '../services/optimizelyService'

export default (landingContext, location, updateGlobalState) => {
  const { globalState, experienceState } = landingContext
  let userId = CookieHelper.get('ico_test_cookie') || uuidv4()
  if (!CookieHelper.get('ico_test_cookie')) {
    CookieHelper.set('ico_test_cookie', userId, '', '', '/', location && location.host)
  }

  const getImageCaptureVariableName = () => {
    const { offerCode, isCombinedOffer, isAssigned, isDigitalRetail, isCobrand, isCobrandDR } = experienceState
    const isDrOffer = offerCode === 'D' || isDigitalRetail
    const isCobrandOffer = offerCode === 'WC' || offerCode === 'OC' || isCobrand
    const isUnassignedOnly = !isAssigned && !isDrOffer && !isCobrandOffer && !isCobrandDR && !isCombinedOffer
    const isAssignedOnly = isAssigned && !isDrOffer && !isCobrandOffer && !isCobrandDR && !isCombinedOffer
    let variableName = ''

    if (isCobrandDR) {
      variableName = 'isImageCaptureWebComponentEnabledForCobrandingDRFury'
    } else if (isUnassignedOnly) {
      variableName = 'isImageCaptureWebComponentEnabledForUnassignedFury'
    } else if (isDrOffer) {
      variableName = 'isImageCaptureWebComponentEnabledForDigitalRetailFury'
    } else if (isAssignedOnly) {
      variableName = 'isImageCaptureWebComponentEnabledForAssignedFury'
    } else if (isCobrand) {
      variableName = 'isImageCaptureWebComponentEnabledForCobrandingFury'
    }
    return variableName
  }

  const getFeaturesToggles = async () => {
    const variablesMap = [
      { featureName: 'imagecapturefeature', variableName: getImageCaptureVariableName(), stateName: 'isImageCaptureWebComponentEnabled', callBack: updateGlobalState },
      { featureName: 'consumerserviceconfig', variableName: 'isConsumerServiceEnabled', stateName: 'consumerInfoToggle', callBack: updateGlobalState },
      { featureName: 'datoffercreationcomponentfury', variableName: 'datoffercreationcomponentfury', stateName: 'isOfferCreationComponentDatEnabled', callBack: updateGlobalState },
      { featureName: 'enableineligiblevehicles', variableName: 'ineligibleVehiclesIsEnabled', stateName: 'isIneligibleVehiclesEnabled', callBack: updateGlobalState },
      { featureName: 'fyusionphotocaptureexperience', variableName: 'isFyusionPhotoCaptureExperienceEnabled', stateName: 'isFyusionPhotoCaptureExperienceEnabled', callBack: updateGlobalState }
    ]

    const featureNames = [...new Set(variablesMap.map(variable => variable.featureName))]
    const result = await getFeaturesVariables({
      globalState,
      params: {
        userId,
        featureNames
      }
    })

    const hasData = result && result.data
    if (!hasData) {
      return
    }

    result.data.forEach(({ featureName, variables }) => {
      const variableObjs = JSON.parse(variables)

      Object.keys(variableObjs).forEach(variableName => {
        const variableObj = variablesMap.find(variableMap => `${variableMap.featureName}:${variableMap.variableName}` === `${featureName}:${variableName}`)

        if (variableObj) {
          const stateName = variableObj.stateName
          const callBack = variableObj.callBack
          const featureValue = variableObjs[variableName]

          if (stateName && callBack === updateGlobalState) {
            updateGlobalState({ [stateName]: featureValue })
            console.log(`set GlobalState ${stateName} with: ${featureValue}`)
          } else {
            callBack(featureValue)
            console.log(`set LandingContext ${stateName} with: ${featureValue}`)
          }
        }
      })
    })
  }

  useEffect(() => {
    getFeaturesToggles()
  }, [])

  experienceState.isOfferCreationComponentDatEnabled = globalState.isOfferCreationComponentDatEnabled

  const expired = landingContext.offer?.isExpired || ['EXPIRED', 'EXPIRED_RESUBMIT'].includes(landingContext.offer?.status)
  const isAdmin = landingContext.experienceState.isAdmin
  experienceState.shouldShowOfferCreationComponent = expired || isAdmin ? experienceState.isOfferCreationComponentDatEnabled : true
  experienceState.isIneligibleVehiclesEnabled = globalState.isIneligibleVehiclesEnabled
}
